<template>
  <footer class="relative bg-brand-800 text-brand-100 pt-12 pb-6 px-6 md:px-16 lg:px-16 xl:px-24">
    <!-- Red stripe like the ribbon in the Delikát logo -->
    <div class="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-brand-800 via-red-600 to-brand-800"></div>

    <div class="max-w-6xl mx-auto">
      <div class="grid gap-10 md:grid-cols-3 mb-10">
        <!-- Brand -->
        <div class="text-center md:text-left">
          <img src="@brand/assets/logo.png" :alt="$brand.siteName" class="mx-auto md:mx-0 mb-4 h-24 drop-shadow-lg">
          <p class="text-lg font-semibold text-white">To najlepšie za najlepšie.</p>
          <p class="text-sm text-brand-200 mt-1">Koreniny a zmesi korenín už od roku 1991.</p>
        </div>

        <!-- Contact -->
        <div class="text-center md:text-left text-sm space-y-2">
          <h3 class="text-white font-semibold uppercase tracking-wide mb-3">Kde nás nájdete</h3>
          <p>{{ $brand.company.address }}</p>
          <p>
            <a :href="$phoneLink()" class="hover:text-white transition-colors">{{ $brand.contact.phone }}</a>
          </p>
          <p v-if="$brand.contact.whatsapp">
            WhatsApp:
            <a :href="whatsappLink" target="_blank" rel="noopener noreferrer"
              class="hover:text-white transition-colors">{{ $brand.contact.whatsapp }}</a>
          </p>
          <p>
            <a :href="`mailto:${$brand.contact.email}`" class="hover:text-white transition-colors">{{
              $brand.contact.email }}</a>
          </p>
          <p v-if="$brand.contact.openingHours" class="text-brand-200">{{ $brand.contact.openingHours }}</p>
        </div>

        <!-- Links -->
        <div class="text-center md:text-left text-sm">
          <h3 class="text-white font-semibold uppercase tracking-wide mb-3">Informácie</h3>
          <ul class="space-y-2">
            <li><router-link :to="$pagePath('about')" class="hover:text-white transition-colors">O nás</router-link>
            </li>
            <li><router-link :to="$pagePath('contact')" class="hover:text-white transition-colors">Kontakt</router-link>
            </li>
            <li v-if="$hasFeature('b2b')"><router-link :to="$pagePath('b2b')"
                class="hover:text-white transition-colors">B2B Program</router-link></li>
            <li><router-link :to="$pagePath('terms')" class="hover:text-white transition-colors">Obchodné podmienky a
                doprava</router-link></li>
            <li><router-link :to="$pagePath('returns')" class="hover:text-white transition-colors">Reklamačný
                poriadok</router-link></li>
            <li><router-link :to="$pagePath('privacy')" class="hover:text-white transition-colors">Ochrana osobných
                údajov</router-link></li>
          </ul>
        </div>
      </div>

      <!-- Bottom -->
      <div
        class="border-t border-brand-600 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-300">
        <p class="text-center sm:text-left">
          © {{ currentYear }} {{ $brand.siteName }} · {{ $brand.company.name }}<template v-if="$brand.company.ico"> ·
            IČO {{ $brand.company.ico }}</template>
          · Delicorp Group
        </p>
        <a href="https://tx-systems.eu" target="_blank" rel="noopener"
          class="group inline-flex items-center gap-1.5 rounded-full bg-brand-900/60 ring-1 ring-brand-600 px-3 py-1.5 hover:ring-brand-300 hover:text-white transition">
          Vytvoril
          <span class="font-semibold text-white">TX Systems</span>
          <ArrowUpRight
            class="h-3.5 w-3.5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup>
import brand from '@/brand'
import { ArrowUpRight } from 'lucide-vue-next'

const currentYear = new Date().getFullYear()
const whatsappLink = `https://wa.me/${(brand.contact.whatsapp || '').replace(/\D/g, '')}`
</script>
